import type { ShowcaseRepository } from "./showcase-repository";

export class LoadShowcase {
  public constructor(private readonly repository: ShowcaseRepository) {}

  public execute() {
    return this.repository.list();
  }
}
